module.exports = __webpack_public_path__ + "static/przelew-na-telefon-ae913e93756c77f296524392c895aac2.jpg";